"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _types = require("../../util/types");

var _OutsideClickWrapper = _interopRequireDefault(require("../OutsideClickWrapper/OutsideClickWrapper"));

var _hooks = require("../../util/hooks");

var _reactstrap = require("reactstrap");

require("./SearchSelection.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Option = function Option(_ref) {
  var option = _ref.option,
      selection = _ref.selection,
      setSelection = _ref.setSelection,
      setOpen = _ref.setOpen,
      swapStyles = _ref.swapStyles;
  var refTooltip = (0, _react.useRef)();
  var refTooltipOptions = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
    className: "gcl-dropdown-item ".concat(option === selection ? '--selected ' : '', " ").concat(swapStyles ? '--nStyles' : ''),
    key: option.id,
    onClick: function onClick() {
      setSelection(option);
      setOpen(false);
    },
    ref: refTooltipOptions
  }, /*#__PURE__*/_react["default"].createElement("span", null, option.text), option.icon && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(option.icon),
    ref: refTooltip
  })), option.tooltiptext && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "top",
    target: refTooltip,
    autohide: false,
    trigger: 'hover'
  }, option.tooltiptext), option.text.length > 34 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "top",
    target: refTooltipOptions,
    boundariesElement: "window"
  }, option.text));
};

var SearchSelection = function SearchSelection(props) {
  var _useState = (0, _react.useState)(props.options),
      _useState2 = _slicedToArray(_useState, 2),
      option = _useState2[0],
      setOption = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      value = _useState6[0],
      setValue = _useState6[1];

  var _useState7 = (0, _react.useState)(undefined),
      _useState8 = _slicedToArray(_useState7, 2),
      selection = _useState8[0],
      setSelection = _useState8[1];

  var inputRef = (0, _react.useRef)();
  var tooltipRef = (0, _react.useRef)();
  var stringifiedData = JSON.stringify(props.options);
  (0, _react.useEffect)(function () {
    if (props.noDefault) return;
    var selected = props.defaultIndex && props.options[props.defaultIndex] ? props.options[props.defaultIndex] : props.options[0];
    setSelection(selected);
  }, [JSON.stringify(props.options)]);
  (0, _react.useEffect)(function () {
    if (isOpen && selection !== undefined) {
      setValue('');
    } else if (!isOpen && selection !== undefined) {
      setValue(selection.text);
    }
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    filterRef.current();
  }, [value, stringifiedData]);

  var toggle = function toggle() {
    return setOpen(!isOpen);
  };

  var setState = function setState(inputValue) {
    if (!props.disabled) {
      if (inputValue.length > 0) setOpen(true);
      setValue(inputValue);

      if (selection !== undefined && inputValue.length === 0) {
        setValue('');
        setSelection(undefined);
      }
    }
  };

  var filter = function filter() {
    var data = Array.isArray(props.options) ? props.options : convertDicToArray(props.options);
    var filteredData = data.filter(arrayFilter);

    if (value.length > 0) {
      filteredData.sort(function (a, b) {
        if (a.text > b.text) {
          return 1;
        }

        if (a.text < b.text) {
          return -1;
        }

        return 0;
      });
    }

    setOption(filteredData);
  };

  var filterRef = (0, _react.useRef)(filter);
  filterRef.current = filter;

  var convertDicToArray = function convertDicToArray(dic) {
    return Object.keys(dic).map(function (key) {
      var element = dic[key];
      element[props.keyResult] = key;
      return element;
    });
  };

  var arrayFilter = function arrayFilter(data) {
    if (_typeof(data) === 'object') {
      if (Array.isArray(data)) {
        // array de arrays
        return data.filter(arrayFilter).some(function (x) {
          return x;
        });
      } //array of objects
      else if (props.filterBy) {
          return searchByKeyIn(data);
        }

      throw new Error("filterBy value wasn't assigned as prop");
    }

    return valueIn(data); //array of string or integers
  };

  var searchByKeyIn = function searchByKeyIn(data) {
    if (Array.isArray(props.filterBy)) {
      return props.filterBy.some(function (element) {
        return element in data ? valueIn(data[element]) : false;
      });
    }

    return props.filterBy in data ? valueIn(data[props.filterBy]) : false;
  };

  var valueIn = function valueIn(data) {
    var stringData = data.toString();
    return props.ignoreCase ? stringData.toLowerCase().includes(value.toLowerCase()) : stringData.includes(value);
  };

  (0, _react.useEffect)(function () {
    if (selection) {
      setValue(selection.text);
      props.onSelected(selection);
    }
  }, [selection]);

  var _useScaledBottomLimit = (0, _hooks.useScaledBottomLimit)(),
      _useScaledBottomLimit2 = _slicedToArray(_useScaledBottomLimit, 2),
      menuRef = _useScaledBottomLimit2[0],
      limit = _useScaledBottomLimit2[1];

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === 'Enter') {
      setSelection(option[0]);
      setOpen(false);
    }
  };

  var handleOnBlur = function handleOnBlur() {
    if (value.length === 0) setValue(selection.text);
  };

  return /*#__PURE__*/_react["default"].createElement(_OutsideClickWrapper["default"], {
    action: function action() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-search-selection-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-search-selection"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-search-selection-body",
    ref: tooltipRef
  }, (selection || isOpen) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-search-selection-body-placeholder ".concat(isOpen ? '--open' : '', " ").concat(isOpen ? '' : selection ? '--selected' : '')
  }, props.placeholder), /*#__PURE__*/_react["default"].createElement("input", {
    ref: inputRef,
    type: props.numeric ? 'number' : 'text',
    onChange: function onChange(e) {
      return setState(e.target.value);
    },
    value: value,
    placeholder: props.placeholder,
    disabled: props.disabled,
    onKeyPress: handleKeyPress,
    onBlur: handleOnBlur
  })), value.length > 30 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "top",
    target: tooltipRef,
    delay: {
      show: 500,
      hide: 100
    },
    boundariesElement: 'window'
  }, value), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-search-selection-icon"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + (isOpen && props.swapStyles ? 'nStyles ' : '') + (isOpen ? 'chevron-up' : 'chevron'),
    onClick: function onClick() {
      !props.disabled && toggle(isOpen);
    }
  }))), isOpen && /*#__PURE__*/_react["default"].createElement("ul", {
    ref: menuRef,
    className: 'gcl-search-selection-dropdown-list' + (props.swapStyles ? ' nStyles' : '')
  }, option.map(function (option, i) {
    return /*#__PURE__*/_react["default"].createElement(Option, {
      key: i,
      option: option,
      selection: selection,
      setSelection: setSelection,
      setOpen: setOpen,
      swapStyles: props.swapStyles
    });
  }))));
};

SearchSelection.propTypes = {
  disabled: _propTypes["default"].bool,
  options: _propTypes["default"].arrayOf(_types.dropdownType).isRequired,
  filterBy: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  //nombre de la(s) propiedade(s) a buscar
  placeholder: _propTypes["default"].string,
  onSelected: _propTypes["default"].func.isRequired,
  swapStyles: _propTypes["default"].bool
};
var _default = SearchSelection;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/SearchSelection/SearchSelection.js
// module id = 1913
// module chunks = 0